import { Box, Inline } from "../../../../../../../../layout";
import { MenuItemChildren, MenuItemChildrenIconText } from "../../types";

type MenuItemContentsProps = {
  children: MenuItemChildren;
  disabled?: boolean;
};

export default function MenuItemContents({
  children,
  disabled
}: MenuItemContentsProps) {
  const onClick = (e: any) => disabled && e.stopPropagation();

  return (
    <Box
      display="flex"
      justifyContent="flex-start"
      alignItems="center"
      minWidth="150px"
      paddingLeft="medium"
      paddingRight="medium"
      onClick={onClick}
    >
      {templated(children) ? (
        <Inline space="large" alignItems="center">
          {children.icon}
          {children.text}
        </Inline>
      ) : (
        children
      )}
    </Box>
  );
}

function templated(
  children: MenuItemChildren
): children is MenuItemChildrenIconText {
  return (
    !!children &&
    typeof children === "object" &&
    !!(children as MenuItemChildrenIconText).icon &&
    !!(children as MenuItemChildrenIconText).text
  );
}
